import { render, staticRenderFns } from "./PortalPendingList.vue?vue&type=template&id=165c1e13&scoped=true&"
import script from "./PortalPendingList.vue?vue&type=script&lang=js&"
export * from "./PortalPendingList.vue?vue&type=script&lang=js&"
import style0 from "./PortalPendingList.vue?vue&type=style&index=0&id=165c1e13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165c1e13",
  null
  
)

export default component.exports